import React from "react";

import AppTable from "components/Shared/AppTable";
import { useTablePagination } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import HighlightedText from "components/Shared/HighlightedText";
import { useLazyVendorBranchReportListQuery } from "store/services/reportApi";
import TableFilter from "components/Shared/AppTable/TableFilter";
import { useSearchParams } from "react-router-dom";
import { Tooltip } from "@mui/material";

const breadcrumbs = [
    { title: "Reports", path: "/app/crm/reports/list" },
    { title: "Vendor Branch Report" },
];

const VendorBranchReport = () => {
  const [searchParams] = useSearchParams();

    const keyword = searchParams.get("search") || "";

    const { currentPage, perPage, handlePageChange, handlePerRowsChange } = useTablePagination();

    const [fetchBranch, { data: branchRes, isLoading, isFetching }] =
        useLazyVendorBranchReportListQuery();

    const columns = [
        {
            name: "Vendor",
            selector: (row) => row?.shopName,
            cell: (row) =>
                row?.shopName ? <HighlightedText text={row.shopName} /> : <span>N/A</span>,
            sortable: true,
        },
        {
            name: "Branches",
            selector: (row) => row?.branchNames?.join(", "),
            cell: (row) => {
                const branches = row?.branchNames || [];

                const visible = branches.slice(0, 2);
                const hidden = branches.slice(2);

                return (
                    <span>
                        {visible.join(", ")}
                        {hidden.length > 0 && (
                            <Tooltip title={hidden.join(", ")}>
                                <span className="text-blue-600 cursor-pointer"> +{hidden.length} more</span>
                            </Tooltip>
                        )}
                    </span>
                );
            },
            sortable: false,
        },
    ];

    React.useEffect(() => {
        fetchBranch({
            page: currentPage,
            limit: perPage,
            keyword: keyword,
        });
    }, [currentPage, fetchBranch, keyword, perPage]);

    return (
        <BreadcrumbLayout breadcrumbs={breadcrumbs}>
            <BreadcrumbLayout.Error />
            <BreadcrumbLayout.Paper>
                <TableFilter searchLabel="Shop Name"></TableFilter>
                <AppTable
                    columns={columns}
                    data={branchRes?.data ?? []}
                    progressPending={isLoading || isFetching}
                    paginationServer
                    paginationPerPage={perPage}
                    paginationTotalRows={branchRes?.totalItems ?? 0}
                    paginationDefaultPage={currentPage}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    );
};

export default VendorBranchReport;
